export const SET_MERCHANT_STATUS = 'SET_MERCHANT_STATUS';

export const setAcademyMerchantStatus = (value: boolean) => ({
  type: SET_MERCHANT_STATUS,
  payload: value,
});
